(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-validate-manual/assets/javascript/router.js') >= 0) return;  svs.modules.push('/modules/tickets-validate-manual/assets/javascript/router.js');
"use strict";


const _svs$app$ReactRouter = svs.app.ReactRouter,
  PlayerRouter = _svs$app$ReactRouter.PlayerRouter,
  Route = _svs$app$ReactRouter.Route;
const baseUrl = svs.core.data.baseUrl;
const Home = svs.ticketsValidateManual.pages.Home;
const ScrollToTop = svs.ticketsValidateManual.components.ScrollToTop;
svs.ticketsValidateManual.logger = svs.core.log.getLogger('tickets-validate-manual');
const Router = () => React.createElement(PlayerRouter, {
  basename: baseUrl,
  withRouter: true
}, React.createElement(ScrollToTop, null), React.createElement(Route, {
  component: Home,
  exact: true,
  path: "/"
}), React.createElement(Route, {
  component: Home,
  exact: true,
  path: "/:ticketId"
}));
const container = document.getElementById('reactContainer');
container && ReactDOM.render(React.createElement(Router, null), container);

 })(window);